/**
 * Accounts API
 */
import { apiClient } from './client'
import type { Account, AccountCreate, AccountUpdate } from '../types'

const BASE_PATH = '/api/accounts'

export const accountsApi = {
  list: async (): Promise<Account[]> => {
    const response = await apiClient.get<Account[]>(BASE_PATH)
    return response.data
  },

  get: async (accountId: string): Promise<Account> => {
    const response = await apiClient.get<Account>(`${BASE_PATH}/${accountId}`)
    return response.data
  },

  create: async (data: AccountCreate): Promise<Account> => {
    const response = await apiClient.post<Account>(BASE_PATH, data)
    return response.data
  },

  update: async (accountId: string, data: AccountUpdate): Promise<Account> => {
    const response = await apiClient.put<Account>(`${BASE_PATH}/${accountId}`, data)
    return response.data
  },

  delete: async (accountId: string): Promise<void> => {
    await apiClient.delete(`${BASE_PATH}/${accountId}`)
  },
}
